import { useState } from 'react';
import { TextField } from '@cimpress/react-components';
import { isStringEmptyOrWhitespace, useUpdateEffect } from '../../../tools';
import type { FontAsset } from './types';

import classes from './FontInput.module.css';

export interface FontInputProps {
    initialValue?: FontAsset;
    label: string;
    required?: boolean;
    onChange: (value?: FontAsset) => void;
}

interface FontState {
    family: string;
}

function assetToState(fontAsset?: FontAsset): FontState {
    return {
        family: fontAsset?.family ?? '',
    };
}

function stateToAsset({ family }: FontState): FontAsset {
    return {
        family,
    };
}

export const FontInput = ({ initialValue, label, onChange }: FontInputProps) => {
    const [font, setFont] = useState(() => assetToState(initialValue));

    useUpdateEffect(() => {
        if (isStringEmptyOrWhitespace(font.family)) {
            onChange(undefined);
        } else {
            onChange(stateToAsset(font));
        }
    }, [font, onChange]);

    const { family } = font;

    return (
        <TextField
            className={classes.inputWrapper}
            label={label}
            value={family}
            onChange={(e) => setFont((prev) => ({ ...prev, family: e.target.value }))}
        />
    );
};
